var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn--darkblue decline-btn",
          attrs: { type: "button", id: "decline_tender" },
          on: {
            click: function ($event) {
              return _vm.init()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("action.declineInvitation")))]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { ref: "alertDeclineModal", attrs: { modalId: "alert-decline-modal" } },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("vendor.bid.decline.popupTitle")) + " "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.closeAlertDeclineModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.openSpecifyReasonModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "specifyReasonModal",
          attrs: { modalId: "specify-reason-modal" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(" " + _vm._s(_vm.$t("vendor.bid.decline.reasonTitle"))),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.declineReason,
                  expression: "declineReason",
                },
                { name: "autosize", rawName: "v-autosize" },
              ],
              staticClass: "autosize",
              class: { "error-highlight": _vm.highlightInvalid },
              attrs: { type: "text", required: "" },
              domProps: { value: _vm.declineReason },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.declineReason = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.apprErrHint
              ? _c(
                  "span",
                  { staticClass: "form-error is-visible appr-error-message" },
                  [_vm._v("\n        " + _vm._s(_vm.apprErrHint) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.closeSpecifyReasonModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.declineInvitation()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "confirmMessageModal",
          attrs: { modalId: "confirm-message-modal" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(_vm._s(_vm.$t("vendor.bid.decline.confirmMessage"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.navHome()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("hint.okay")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }